import adminTR from './admin.json';
import agentTR from './agent.json';
import affiliatesTR from './affiliates.json';
import attributionsTR from './attributions.json';
import auditTR from './audit.json';
import authenticationTR from './authentication.json';
import brandTR from './brand.json';
import commonTR from './common.json';
import contentTR from './content.json';
import countryTR from './country.json';
import crmTranslationTR from './crm.json';
import dashboardTR from './dashboard.json';
import documentTR from './document.json';
import engagementTR from './engagement.json';
import errorsTR from './errors.json';
import filterTR from './filter.json';
import financeTranslationTR from './finance.json';
import languageTR from './language.json';
import notificationTR from './notifications.json';
import promotionsTR from './promotions.json';
import permissionsTR from './permissions.json';
import reportsTR from './reports.json';
import retailTR from './retail.json';
import rolesTR from './roles.json';
import statesOfMexicoTR from './statesOfMexico.json';
import workflowTR from './workflow.json';
import pageTitlesTR from './pageTitles.json'

export default {
  ...adminTR,
  ...agentTR,
  ...affiliatesTR,
  ...attributionsTR,
  ...auditTR,
  ...authenticationTR,
  ...brandTR,
  ...commonTR,
  ...contentTR,
  ...countryTR,
  ...crmTranslationTR,
  ...dashboardTR,
  ...documentTR,
  ...engagementTR,
  ...errorsTR,
  ...filterTR,
  ...financeTranslationTR,
  ...languageTR,
  ...notificationTR,
  ...permissionsTR,
  ...promotionsTR,
  ...reportsTR,
  ...retailTR,
  ...rolesTR,
  ...statesOfMexicoTR,
  ...workflowTR,
  ...pageTitlesTR,
};
